import React from 'react';
import { TouchDropdown } from './TouchDropdown';
import { SubCategoryNameDisplay } from './SubCategoryNameDisplay';

interface TouchActionsProps {
  sellerUserName: string;
  gigSlug: string;
  subCategoryName: string;
  onGigLinkClick: () => void;
  onSellerLinkClick: () => void;
}

export const TouchActions = ({
  subCategoryName,
  sellerUserName,
  gigSlug,
  onGigLinkClick,
  onSellerLinkClick,
}: TouchActionsProps) => {
  return (
    <div className="flex flex-justify-between flex-items-center m-t-4">
      <SubCategoryNameDisplay subCategoryName={subCategoryName} />
      <div className="m-l-16">
        <TouchDropdown
          sellerUserName={sellerUserName}
          gigSlug={gigSlug}
          onGigLinkClick={onGigLinkClick}
          onSellerLinkClick={onSellerLinkClick}
        />
      </div>
    </div>
  );
};
